'use strict';

var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Document = require("rescript-webapi/lib/js/src/Webapi/Dom/Webapi__Dom__Document.js");

function processRawCookies(cookies) {
  var search = {
    sessionId: undefined,
    token: undefined
  };
  cookies.split("; ").map(function (param) {
          return param.split("=");
        }).forEach(function (cookieArr) {
        if (cookieArr.length !== 2) {
          return ;
        }
        var match = cookieArr[0];
        switch (match) {
          case "sessionId" :
              var value = cookieArr[1];
              var sessionId = Belt_Int.fromString(value);
              if (sessionId !== undefined) {
                search.sessionId = sessionId;
                return ;
              } else {
                return ;
              }
          case "token" :
              var value$1 = cookieArr[1];
              search.token = value$1;
              return ;
          default:
            return ;
        }
      });
  return search;
}

function getSessionCookies(param) {
  var htmlDocument = Webapi__Dom__Document.asHtmlDocument(document);
  if (htmlDocument === undefined) {
    return ;
  }
  var cookies = processRawCookies(Caml_option.valFromOption(htmlDocument).cookie);
  var sessionId = cookies.sessionId;
  if (sessionId === undefined) {
    return ;
  }
  var token = cookies.token;
  if (token !== undefined) {
    return {
            sessionId: sessionId,
            token: token
          };
  }
  
}

exports.getSessionCookies = getSessionCookies;
/* Webapi__Dom__Document Not a pure module */
